import React, { useState, useEffect, useMemo } from 'react';
import '@ant-design/compatible/assets/index.css';
import { Button, Row, Col, Form, Modal, Input, Upload, Switch } from 'antd';
import * as productTagService from 'redux/services/productTag';

const normFile = e => {
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};
const AddForm = props => {
  const tag = props.tag;
  const initialValues = useMemo(
    () =>
      tag
        ? { name: tag.name, description: tag.description, allowFiltering: tag.allowFiltering }
        : { allowFiltering: true },
    [tag]
  );
  const [form] = Form.useForm();
  const [image, setImage] = useState(null);

  useEffect(() => {
    if (tag) {
      form.setFieldsValue(initialValues);
      setImage(null);
    }
  }, [tag, form, initialValues]);

  const beforeUpload = file => {
    setImage(file);
    return false;
  };

  return (
    props.visible &&
    tag && (
      <Modal
        visible={true}
        destroyOnClose={true}
        onCancel={props.handleClose}
        title={(tag.id ? 'Update' : 'Create') + ' Product Tag'}
        okText={tag.id ? 'Update' : 'Create'}
        onOk={() => {
          form
            .validateFields()
            .then(values => {
              const formData = new FormData();
              formData.append('name', values.name);
              formData.append('description', values.description);
              formData.append('allowFiltering', values.allowFiltering);
              formData.append('image', image);
              return tag.id ? productTagService.update(tag.id, formData) : productTagService.create(formData);
            })
            .then(_ => {
              form.resetFields();
              props.handleClose();
            })
            .catch(info => {
              console.log('Validate Failed:', info);
            });
        }}
      >
        <Form form={form} layout="vertical" initialValues={initialValues}>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: 'Name is required'
                  }
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Description"
                name="description"
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: 'Description is required'
                  }
                ]}
              >
                <Input.TextArea />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="Allow Filtering" name="allowFiltering" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Image"
                name="image"
                rules={[{ required: !tag.id, message: 'Image is required' }]}
                valuePropName="fileList"
                getValueFromEvent={normFile}
              >
                <Upload beforeUpload={beforeUpload} accept="image/*" maxCount={1}>
                  <Button>Click to upload</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    )
  );
};

export default AddForm;
